import AccountController from "./controller";
import AccountComponents from "./components/module";
import AccountProfileModule from "./profile/module";
import AccountBookingsModule from "./bookings/module";
import AccountChangePasswordModule from "./change-password/module";
import AccountCreateModule from "./create/module";
import AccountResetPasswordModule from "./reset-password/module";
import AccountResetPasswordRequestModule from "./reset-password-request/module";
import AccountLogoutModule from "./logout/module";

const modul = angular
    .module("Account", [
        AccountProfileModule,
        AccountBookingsModule,
        AccountChangePasswordModule,
        AccountComponents,
        AccountCreateModule,
        AccountResetPasswordModule,
        AccountResetPasswordRequestModule,
        AccountLogoutModule,
    ])

    .controller("AccountController", AccountController);

export default modul.name;
